import { Grid, InputLabel, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ObjectToFormdata } from '../../../Common/Utils/common_utils'
import CustomDatePicker from '../../../Components/CustomDatePicker'
import CustomInput from '../../../Components/CustomInput'
import CustomRadioButton from '../../../Components/CustomRadioButton'
import CustomSelect from '../../../Components/CustomSelect'
import CircularIndeterminate from '../../../Components/Loader'
import { showSnackbar } from '../../../Components/Snackbar/SnackbarActions'
import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions'
import AdminPartnerClient from '../../../Service/Admin/partner_services'
import Header from './header'

const AssociateCoaches = (props: any) => {
    const classes = useStyles();
    const data = {
        job_role: '',
        bio_paragraph: '',
    }
    const [userData, setUserData] = useState(data);
    const [loading, setLoading] = useState(false);
    const global_data = useSelector((state: any) => state.stepperReducer);
    const dispatch = useDispatch();

    const setInputState = (inputStateValue: any, inputId: any) => {
        setUserData({ ...userData, [inputId]: inputStateValue })
        console.log(inputStateValue)
    }
    const firstElementRef = useRef(null);
    useEffect(() => {
            window.scrollTo(0,0);   
            if(firstElementRef.current){
                //@ts-ignore
                firstElementRef.current.scrollIntoView();
              }      
        if (global_data.associate_coaches_id != null) {
            setLoading(true)
            AdminPartnerClient.AssociateCoaches(
                global_data.associate_coaches_id,
                { partner_profile_id: global_data.partner_profile },
                'GET'
            ).then((response: any) => {
                setLoading(false)
                setUserData(response.data.attributes)

            }).catch(() => {
                setLoading(false)
            });

        }
    }, [])

    const onSubmit = () => {
        console.log(userData)
        setLoading(true)
        if (global_data.associate_coaches_id == null) {

            AdminPartnerClient.AssociateCoaches(
                '',
                ObjectToFormdata({ partner_profile_id: global_data.partner_profile, ...userData }),
                'POST'
            ).then((response: any) => {
                dispatch({ type: GLOBAL_STEPPER_DATA, payload: { associate_coaches_id: response.data.id } });
                dispatch(showSnackbar("Success", ["Information saved successfully"]))
                props.parentHandleNext(props.activeIndex + 1)
                setLoading(false)
            }).catch(() => {
                setLoading(false)
            });

        } else {
            AdminPartnerClient.AssociateCoaches(
                global_data.associate_coaches_id,
                ObjectToFormdata({ ...userData }),
                "PUT"
            ).then(() => {
                props.parentHandleNext(props.activeIndex + 1)
                dispatch(showSnackbar("Success", ["Information updated successfully"]))
                setLoading(false)
            }).catch(() => {
                setLoading(false)
            });
        }

    }
    const onBack = () => {
        props.parentHandleNext(props.activeIndex - 1)
    }
    return (
        <div style={{ marginBottom: 40 }} ref={firstElementRef}>
            {/* <Header parentcall={onSubmit} /> */}
            <Grid container direction="row" alignItems="flex-start" style={{ padding: 30, marginBottom: 30 }}>
                <Grid item xs={10}>
                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Associate job role</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="job_role" variant="outlined" placeholder="Associate job role" parentcall={setInputState} value={userData.job_role} />
                        </Grid>
                    </Grid>

                    <Grid container direction="row" alignItems="center" style={{ marginBottom: 30 }}>
                        <Grid item xs={4}>
                            <Typography variant="h2">Associate bio paragraph</Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <CustomInput id="bio_paragraph" multiline={true} rows={4} variant="outlined" placeholder="Associate bio paragraph" parentcall={setInputState} value={userData.bio_paragraph} />
                        </Grid>
                    </Grid>


                </Grid>
            </Grid>
            <Header saveBtnTitle={'Save & Proceed'} isBack={true} parentcall={onSubmit} parentBackCall={onBack} />
            {loading && <CircularIndeterminate />}
        </div >
    )
}
export default AssociateCoaches
const useStyles = makeStyles((theme) => ({
    labelText: {
        color: '#4D4F5C',
        fontSize: '16px',
        lineHeight: '22px',
        paddingRight: '10px'
    },
}))
